import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import { Auth } from '@aws-amplify/auth';

Vue.config.productionTip = false;

// Amplify for OIDC logins
Auth.configure({
  // Amazon Cognito Region
  region: 'us-east-2',
  // Amazon Cognito User Pool ID
  userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  // Amazon Cognito Web Client ID
  userPoolWebClientId: process.env.VUE_APP_COGNITO_OAUTH_CLIENT_ID,
  oauth: {
    domain: process.env.VUE_APP_COGNITO_OAUTH_URL,
    scope: [
      'openid',
    ],
    redirectSignIn: `${window.location.origin}/portal/index.html`,
    redirectSignOut: `${window.location.origin}/portal/index.html?signed_out=true&federated_sign_out=true`,
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
});

new Vue({
  render: (h) => h(App),
}).$mount('#app');
